var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"beamerTrigger pa-3 ml-2",attrs:{"icon":""},on:{"click":function($event){_vm.beamerHasNewPosts = false}}},[(_vm.beamerHasNewPosts)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-bell")]):_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-bell-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }